const styles = {
  paper: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    minHeight: 400,
    gap: 3,
  },
  text: {
    color: "#DDEBDE",
    fontSize: "14px",
    fontWeight: 600,
    whiteSpace: "nowrap",
  },
};
export default styles;
